// PDP alt bölümleri · Product Page v2 §4-5.
//   pdp-related: Shopify ürün önerileri, Section Rendering ile (öneri yoksa hiçbir şey)
//   pdp-from-your-studio: cihazdaki ya da hesaptaki Studio tasarımları (/apps/studio/api/state);
//   yoksa davet. Tasarımlar bu ürüne değil kişiye ait: en yeniler, bu üründen customize
//   edilenler önce.

import { api, decode } from "walldora-studio";

async function related() {
  const slot = document.querySelector("[data-wd-recs]");
  if (!slot) return;
  try {
    const html = await (await fetch(slot.dataset.url)).text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const block = doc.querySelector(".wd-pdp-more");
    if (block) slot.replaceWith(block);
    else slot.remove();
  } catch {
    slot.remove();
  }
}

async function studioBand() {
  const band = document.querySelector("[data-wd-studio-band]");
  if (!band) return;
  const t = decode(JSON.parse(band.querySelector("[data-wd-band-i18n]").textContent));
  let designs = [];
  try {
    designs = ((await api("/state")).designs ?? []).filter((d) => d.status === "ready" && d.thumb);
  } catch {}
  const handle = band.dataset.product;
  designs.sort((a, b) => (b.source === handle) - (a.source === handle) || b.createdAt - a.createdAt);

  const title = band.querySelector("[data-wd-band-title]");
  title.textContent = designs.length ? title.dataset.made : title.dataset.empty;
  band.querySelector("[data-wd-band-empty]").hidden = designs.length > 0;
  const all = band.querySelector("[data-wd-band-all]");
  all.hidden = designs.length === 0;
  all.textContent = `${all.dataset.template.replace("%count", designs.length)} →`;

  const row = band.querySelector("[data-wd-band-row]");
  const template = band.querySelector("[data-wd-band-item]");
  const date = new Intl.DateTimeFormat("en-US", { day: "2-digit", month: "short" });
  row.replaceChildren(
    ...designs.slice(0, 8).map((d, i) => {
      const node = template.content.firstElementChild.cloneNode(true);
      node.href = `${band.dataset.base}apps/studio?design=${encodeURIComponent(d.id)}`;
      node.querySelector(".wd-studio-band__n").textContent = String(i + 1).padStart(2, "0");
      node.querySelector(".wd-studio-band__date").textContent = date.format(new Date(d.createdAt));
      const img = node.querySelector(".wd-studio-band__media > img");
      img.src = d.thumb;
      img.alt = `${t.formats[d.format] || ""} ${d.id}`.trim();
      // Oran: duvar görüntüsü geniş, mural dikeyse dar, karo kare
      const ratio = d.width && d.height ? d.width / d.height : 1;
      node.querySelector(".wd-studio-band__media").dataset.ratio = ratio > 1.15 ? "wide" : ratio < 0.87 ? "tall" : "square";
      node.querySelector(".wd-studio-band__kind span").textContent = t.kinds[d.mode] || t.kinds.studio;
      const what = (d.subject || d.prompt || "").trim();
      node.querySelector(".wd-studio-band__what").textContent = what ? (what.length > 32 ? `${what.slice(0, 31)}…` : what) : d.id;
      node.querySelector(".wd-studio-band__from").textContent = d.source === handle ? t.from_this.replace("%title", band.dataset.title) : t.from_studio;
      return node;
    }),
    // Sonda "New design": boş Studio (Customize ürün görselinde zaten var)
    ...(designs.length ? [band.querySelector("[data-wd-band-new]").content.firstElementChild.cloneNode(true)] : [])
  );
  row.hidden = designs.length === 0;
  band.hidden = false;
}

related();
studioBand();
